class SizeChartButton extends HTMLElement {
  connectedCallback() {
    const image = this.getAttribute("image") || "";
    const label = this.textContent.trim() || "Size Chart";

    this.innerHTML = `
      <span class="size-chart-btn">${label}</span>

      <div class="size-chart-modal">
        <div class="size-chart-content">
          <svg class="size-chart-close" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M22.6668 9.33331L9.3335 22.6666" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.3335 9.33331L22.6668 22.6666" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <img src="${image}" alt="Size Chart">
        </div>
      </div>
    `;

    const btn = this.querySelector(".size-chart-btn");
    const modal = this.querySelector(".size-chart-modal");
    const close = this.querySelector(".size-chart-close");

    btn.addEventListener("click", () => modal.classList.add("open"));
    close.addEventListener("click", () => modal.classList.remove("open"));

    modal.addEventListener("click", (e) => {
      if (e.target === modal) modal.classList.remove("open");
    });
  }
}

customElements.define("size-chart-button", SizeChartButton);
